import React, { useState } from 'react';
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { tokens } from '../theme';
import { apiErrorMessage } from '../utils/apiError';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const currentUser = await login({ username, password });
      navigate(currentUser.role === 'KALOTTE_OPERATOR' ? '/production' : '/certificates');
    } catch (err: any) {
      setError(
        apiErrorMessage(err, 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.')
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
      }}
    >
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          bgcolor: tokens.fg,
          color: '#fafafa',
          px: 6,
          py: 6,
        }}
      >
        <Box>
          <Box
            component="img"
            src="/kalotte-logo.svg"
            alt="Kalotte"
            sx={{ width: 240, maxWidth: '100%', height: 'auto', display: 'block' }}
          />
          <Typography sx={{ mt: 2.5, color: '#a3a3a3', maxWidth: 280 }}>
            Werkszeugnisse, Chargen und Produktion.
          </Typography>
        </Box>
        <Typography variant="caption" sx={{ color: '#737373' }}>
          kalotte.eu
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', px: 3, py: 6 }}>
        <Box sx={{ width: '100%', maxWidth: 360 }}>
          <Box
            component="img"
            src="/kalotte-logo.svg"
            alt="Kalotte"
            sx={{
              display: { xs: 'block', md: 'none' },
              width: 180,
              height: 'auto',
              mb: 3,
            }}
          />
          <Typography component="h1" variant="h4" sx={{ mb: 0.5 }}>
            Anmelden
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3, fontSize: 13 }}>
            Kalotte Material Lieferanten Zertifikate
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Benutzername"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Passwort"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
              disabled={loading || !username || !password}
            >
              {loading ? 'Anmelden...' : 'Anmelden'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginPage;
